"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Base = _interopRequireDefault(require("ol/layer/Base"));

var _antd = require("antd");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOpts = function getOpts(layer) {
  if (layer instanceof _Base.default) {
    var sourceOpts = {
      source: {
        url: layer.getSource().getUrl(),
        params: {
          FEATURE_COUNT: layer.getSource().getParams().FEATURE_COUNT || undefined,
          FORMAT: layer.getSource().getParams().FORMAT,
          LAYERS: layer.getSource().getParams().LAYERS,
          STYLES: layer.getSource().getParams().STYLES,
          VERSION: layer.getSource().getParams().VERSION,
          CQL_FILTER: layer.getSource().getParams().CQL_FILTER,
          INFO_FORMAT: layer.getSource().getParams().INFO_FORMAT
        }
      }
    };
    return sourceOpts;
  }
};

var ImageWMSSourceTab = function ImageWMSSourceTab(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'url'],
      label: "URL",
      rules: [{
        required: true
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'FEATURE_COUNT'],
      label: "Feature Count" // rules={[
      //     {
      //         //required: true,
      //     },
      // ]}
      ,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'FORMAT'],
      label: "Format",
      rules: [{//required: true,
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'LAYERS'],
      label: "Layers",
      rules: [{
        required: true
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'STYLES'],
      label: "Styles",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'VERSION'],
      label: "Version",
      rules: [{//required: true,
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'CQL_FILTER'],
      label: "CQL Filter",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input.TextArea, {
        allowClear: true
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: ['source', 'params', 'INFO_FORMAT'],
      label: "FeatureInfo Format",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    })]
  });
};

ImageWMSSourceTab.getOpts = getOpts;
var _default = ImageWMSSourceTab;
exports.default = _default;